module.exports = __webpack_public_path__ + "img/dashboard-background@2x.c2d25430.png";